import hexagonH3 from "./analytic-symbol/hex-h3.svg";
import cluster from "./analytic-symbol/cluster.svg";
import clusterDiagram from "./analytic-symbol/diagram.svg";
import heatMap from "./analytic-symbol/heat-map.svg";
import hexagon from "./analytic-symbol/hex.svg";
import polygonVoronoy from "./analytic-symbol/poly-voron.svg";
import polygonS2 from "./analytic-symbol/poly-s2.svg";
import clusterPro from "./analytic-symbol/cluster-pro.svg";
import defaultH3Symbol from "./analytic-symbol/default-h3-symbol.svg";

export const images = {
  hexagonH3,
  cluster,
  clusterDiagram,
  heatMap,
  hexagon,
  polygonVoronoy,
  polygonS2,
  clusterPro,
  defaultH3Symbol,
};
